module.exports = __webpack_public_path__ + "static/media/massimo.72327c0d.jpeg";